// frontend/src/services/api.js
const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.lamilara.com/api';

function getToken() {
  return localStorage.getItem('calleb_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    credentials: 'include',   // envía cookies automáticamente
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });

  if (res.headers.get('content-type')?.includes('application/pdf')) {
    const blob = await res.blob();
    const numeroRecibo = res.headers.get('X-Numero-Recibo') || 'recibo';
    return { blob, numeroRecibo };
  }

  const data = await res.json();
  if (res.status === 401) {
    localStorage.removeItem('calleb_token');
    localStorage.removeItem('calleb_usuario');
    window.location.reload();
    return;
  }
  if (!res.ok) throw new Error(data.mensaje || `Error ${res.status}`);
  return data;
}

export const casasApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([,v]) => v))
    ).toString();
    return request(`/casas${qs ? `?${qs}` : ''}`);
  },
  detalle: (id) => request(`/casas/${id}`),
  registrarPago: async (id, datos) => {
    const token = getToken();
    const res = await fetch(`${BASE_URL}/casas/${id}/pago`, {
      method:      'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization:`Bearer ${token}` } : {}),
      },
      body: JSON.stringify(datos),
    });
    if (res.headers.get('content-type')?.includes('application/pdf')) {
      const blob = await res.blob();
      const numeroRecibo = res.headers.get('X-Numero-Recibo') || 'recibo';
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      return { ok:true, numeroRecibo };
    }
    const data = await res.json();
    if (!res.ok) throw new Error(data.mensaje);
    return data;
  },
};

export const dashboardApi = {
  flujoCaja: (anio) => request(`/casas/dashboard/${anio}`),
};

export const adminApi = {
  facturacionAnual: (anio, generado_por='ADMIN') =>
    request('/casas/facturacion-anual', {
      method:'POST', body:JSON.stringify({ anio_fiscal:anio, generado_por }),
    }),
  cuotaExtraordinaria: (datos) =>
    request('/casas/cuota-extraordinaria', {
      method:'POST', body:JSON.stringify(datos),
    }),
};

export const importarApi = {
  subir: (archivo, anioFiscal) => {
    const form = new FormData();
    form.append('archivo', archivo);
    form.append('anio_fiscal', anioFiscal);
    const token = getToken();
    return fetch(`${BASE_URL}/importar`, {
      method:      'POST',
      credentials: 'include',
      body:        form,
      headers:     token ? { Authorization:`Bearer ${token}` } : {},
    }).then(r => r.json());
  },
};
// cache bust Sun Jun 21 13:24:28 -04 2026
